import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import OpportunityStore from "../../../stores/opportunityStore";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./description.css";

interface IParams {
  opId: string;
}

@inject("store") @observer
export class Description extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div>
      <Row>
        <Col xsOffset={1} xs={10} smOffset={2} sm={8} >
          <h4 className={s.header}>{local.descriptionHeader}</h4>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col xs={12} smOffset={1} sm={10} >
          {this._opStore.selectedOp.postedBy !== null  && <p className={s.employer}>{`${local.opportunity.employer}: ${this._opStore.selectedOp.postedBy}`}</p>}
          {(this._opStore.selectedOp.description === null || this._opStore.selectedOp.description === "") && <div><p className={s.noDescriptionText}>{local.noDescription}</p></div>}
          <div className={s.bodyText} dangerouslySetInnerHTML={{ __html: this._opStore.selectedOp.description }}></div>
        </Col>
      </Row>
    </div>)}
}


// WEBPACK FOOTER //
// ./src/components/opportunity/description/index.tsx